import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { first } from 'rxjs/operators';
import { profileType, User } from 'src/app/models/user.model';
import { DbService } from 'src/app/services/db.service';
import { AlertService } from 'src/app/services/alert.service';
import { SwiperContainer } from 'swiper/element';

@Component({
  selector: 'app-profile-detail-list',
  templateUrl: './profile-detail-list.page.html',
  styleUrls: ['./profile-detail-list.page.scss'],
})
export class ProfileDetailListPage implements OnInit {
  @ViewChild('swiperRefProfile', { static: false }) swiperRefProfile!: ElementRef<SwiperContainer>;

  slideIndex;

  myUid: string = localStorage.getItem('userId') ?? ''; // 나의 uid
  userId: string = ''; // 상대방 uid

  type: string = '';
  profiles: Array<profileType> = [];

  // 현재 보고있는 페이지!
  currentViewIdx: number = 0;

  constructor(
    private modalController: ModalController, 
    private db: DbService, 
    private navParams: NavParams, 
    private alert: AlertService,
  ) {
    this.userId = this.navParams.get('userId');
    this.type = this.navParams.get('type');
    this.getData();
  }

  ngOnInit() {
    
  }

  ngAfterViewInit() {
    const swiperContainer = this.swiperRefProfile.nativeElement;
    swiperContainer.swiper.on('slideChange', () => {
      this.currentViewIdx = swiperContainer.swiper.activeIndex;
    });
  }

  async getData(): Promise<void> {
    const user: User = await this.db.doc$(`user/${this.userId}`).pipe(first()).toPromise();
    if (this.type == 'defaultProfiles') {
      this.profiles = user.defaultProfiles ? user.defaultProfiles : [];
    } else {
      this.profiles = user.bgProfiles ? user.bgProfiles : [];
    }
  }

  //내아이디 맞나 확인
  get isMe(): boolean {
    return this.myUid == this.userId;
  }

  // 프로필 내용을 삭제 처리
  async deleteProfile(): Promise<void | boolean> {
    const art = await this.alert.cancelOkBtn('삭제하시겠습니까', '취소', '삭제');
    if (!art) {
      return false;
    }

    this.profiles.splice(this.currentViewIdx, 1);

    if (this.type == 'defaultProfiles') {
      await this.db.updateAt(`user/${this.myUid}`, {
        defaultProfiles: this.profiles,
      });
    } else {
      await this.db.updateAt(`user/${this.myUid}`, {
        bgProfiles: this.profiles,
      });
    }
  }

  //모달닫기
  dismiss() {
    this.modalController.dismiss();
  }
}
